<template>
  <div :class="readinessView ? 'readiness-view-proficiency-badge':''" class="ex-readiness-badge">
    <v-chip v-if="plain === false && mini === false && !firstName && !lastName" :class="classes">
      <v-badge v-if="dot !== 'No Dot' && level !== 'Novice'" :color="getStatusColor" dot class="prop-custom-bedge"></v-badge>
      <EXTooltip
          placement="top"
          :title="getTooltipValue"
          :delay="500"
      >
        <span :class="textClasses" class="prop-status-label" v-if="!acting_as_coach && !acting_as_master">{{ level }}</span>
        <span :class="textClasses" class="prop-status-label" v-if="acting_as_coach">Acting as {{ level }}</span>
        <span :class="textClasses" class="prop-status-label" v-if="acting_as_master">Acting as {{ level }}</span>
      </EXTooltip>
      <span v-if="view === 'Editable' && level === 'Novice' && showNoviceButton" class="novice-btn" @click="noviceBadge(level)">
        <img :src="require(`@components/assets/novicePlusIcon.svg`)" class="novice-plus" alt="icon">
        <img :src="require(`@components/assets/noviceProficiency.svg`)" class="novice-badge" alt="icon">
      </span>
      <div v-if="(view === 'Editable' || view == 'Upgraded') && level !== 'Novice'" :class="`${!upgradedVariantIcon ? 'ex-badge-icon' : 'badge-icon'}`">
        <ExpireIcon
          v-if="!upgradedVariantIcon && !hideIcons && showExpirationIconFeature"
          :icon="expirationIconVariant"
          :badgeLevel="level"
          :expirationDate="expiration_date"
          :days="expires_in_days_from_becoming_obsolete || 0"
          :badgeStatus="expirationIconBadgeStatus"
          :policy="expirationIconPolicy"
          @save="handleExpirationSave"
          @remove="handleExpirationRemove"
          @setToGoodStanding="handleSetToGoodStanding"
          @makeObsolete="handleMakeObsolete"
        />
        <EXTooltip
          v-else-if="upgradedVariantIcon && !hideIcons"
          placement="bottom"
          :title="`${upgradedVariantIcon}`"
        >
          <v-icon class="ml-2" style="max-height: 16px; max-width: 16px">{{ `$ex-proficiency-badge-${upgradedVariantIcon}` }}</v-icon>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Obsolete' && level !== 'Novice' && showExpirationIcon && has_expiration_if_obsolete" class="ex-badge-icon">
        <ExpireIcon
          v-if="showExpirationIconFeature"
          icon="if_obsolete"
          :badgeLevel="level"
          :expirationDate="expiration_date"
        />
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Obsolete' && level !== 'Novice' && showAboutExpirationIcon && has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to expire ${showExpirationDays} days`"
          :description="`Unless it is brought back to Good Standing, it is set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_about_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot !== 'Given' && level !== 'Novice' && showExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days`"
          :description="`It is Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot !== 'Given' && level !== 'Novice' && showAboutExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to Expire in ${showExpirationDays} days`"
          :description="`It is Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_about_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Good Standing' && level !== 'Novice' && expiration_date !== null && has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days if at that time the badge is obsolete`"
          :description="`Unless it is in Good Standing at expiration date, it is set to expire on ${showExpirationDate}. Otherwise we will attempt to expire the badge every ${retries_to_expire_in_days}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_has_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && level !== 'Novice' && expiration_date === null && showExpirationIconFeature" class="ex-badge-icon">
        <EXTooltip
          placement="bottom"
          title="Does Not expire"
          :children="true"
        >
          <template #icon>
            <ExpireIcon
              icon="read_only"
              :badgeLevel="level"
              :expirationDate="expiration_date"
            />
          </template>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && showExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="ex-badge-icon">
        <ExpireIcon
          :icon="expirationIconVariant"
          :badgeLevel="level"
          :expirationDate="expiration_date"
          :days="expires_in_days_from_becoming_obsolete || 0"
          :badgeStatus="expirationIconBadgeStatus"
          :policy="expirationIconPolicy"
          @save="handleExpirationSave"
          @remove="handleExpirationRemove"
          @setToGoodStanding="handleSetToGoodStanding"
          @makeObsolete="handleMakeObsolete"
        />
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && showAboutExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="ex-badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to expire in ${showExpirationDays} days`"
          :description="`Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <ExpireIcon
              icon="soon"
              :badgeLevel="level"
              :expirationDate="expiration_date"
            />
          </template>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && showTodayExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="ex-badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to expire in today`"
          :description="`Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <ExpireIcon
              icon="tonight"
              :badgeLevel="level"
              :expirationDate="expiration_date"
            />
          </template>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'Expired' && level !== 'Novice' && expiration_date === null" class="badge-icon">
        <EXTooltip
          placement="bottom"
          title="This Badge is expired"
          :children="true"
        >
          <template #icon>
            <Icon name="expired_icon" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'Terminated' && level !== 'Novice' && expiration_date === null" class="badge-icon">
        <EXTooltip
          placement="bottom"
          title="This Badge is terminated"
          :children="true"
        >
          <template #icon>
            <Icon name="terminated_icon" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'Removed' && level !== 'Novice' && expiration_date === null" class="badge-icon">
        <EXTooltip
          placement="bottom"
          title="This Badge is removed"
          :children="true"
        >
          <template #icon>
            <Icon name="removed_icon" />
          </template>
        </EXTooltip>
      </div>
      <EXTooltip
          placement="top"
          title="Remove"
          :delay="500"
          v-if="view === 'Editable' && level !== 'Novice' && !upgraded && !hideRemoveIcon"
              >
          <div class="d-flex align-center">
            <img
              :src="isHovering ? require(`@components/assets/badge-hover-cross-icon.svg`) : require(`@components/assets/badge-cross-icon.png`)"
              alt="icon"
              @click="removeBadge(level)"
              class="badge-cross-icon"
              :class="'hover-cross-' + level"
              @mouseover="isHovering = true"
              @mouseleave="isHovering = false"
          >
        </div>
      </EXTooltip>
      <EXTooltip
          placement="top"
          title="Remove"
          :delay="500"
          v-if="view === 'ReadOnly' && level !== 'Novice' && !upgraded && expiration_date !== null && !hideRemoveIcon"
      >
        <div class="d-flex align-center">
          <img
              :src="isHovering ? require(`@components/assets/badge-hover-cross-icon.svg`) : require(`@components/assets/badge-cross-icon.png`)"
              alt="icon"
              @click="removeBadge(level)"
              class="badge-cross-icon"
              :class="'hover-cross-' + level"
              @mouseover="isHovering = true"
              @mouseleave="isHovering = false"
          >
        </div>
      </EXTooltip>
    </v-chip>
    <v-chip v-if="plain === false && mini === true" :class="miniClasses">
      <v-badge v-if="dot !== 'No Dot' && level !== 'Novice'" :color="getStatusColor" dot class="prop-custom-bedge"></v-badge>
      <span :class="textClasses" class="prop-status-label"></span>
      <span v-if="view === 'Editable' && level === 'Novice'" class="novice-btn" @click="noviceBadge(level)">
        <img :src="require(`@components/assets/novicePlusIcon.svg`)" class="novice-plus" alt="icon">
        <img :src="require(`@components/assets/noviceProficiency.svg`)" class="novice-badge" alt="icon">
      </span>
      <div v-if="view === 'Editable' && level !== 'Novice' && showExpirationIconFeature" class="ex-badge-icon">
        <ExpireIcon
          :icon="expirationIconVariant"
          :badgeLevel="level"
          :expirationDate="expiration_date"
          :days="expires_in_days_from_becoming_obsolete || 0"
          :badgeStatus="expirationIconBadgeStatus"
          :policy="expirationIconPolicy"
          @save="handleExpirationSave"
          @remove="handleExpirationRemove"
          @setToGoodStanding="handleSetToGoodStanding"
          @makeObsolete="handleMakeObsolete"
        />
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot !== 'Given' && level !== 'Novice' && expiration_date === null && showExpirationIconFeature" class="ex-badge-icon">
        <EXTooltip
          placement="bottom"
          title="This Badge does NOT expire"
          :children="true"
        >
          <template #icon>
            <ExpireIcon
              icon="add"
              :badgeLevel="level"
              :size="'small'"
              :expirationDate="expiration_date"
            />
          </template>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Obsolete' && level !== 'Novice' && showExpirationIcon && has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days`"
          :description="`Unless it is brought back to Good Standing, it is set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_has_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Obsolete' && level !== 'Novice' && showAboutExpirationIcon && has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to expire ${showExpirationDays} days`"
          :description="`Unless it is brought back to Good Standing, it is set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_about_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot !== 'Given' && level !== 'Novice' && showExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days`"
          :description="`It is Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot !== 'Given' && level !== 'Novice' && showAboutExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to Expire in ${showExpirationDays} days`"
          :description="`It is Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_about_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Good Standing' && level !== 'Novice' && expiration_date !== null && has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days if at that time the badge is obsolete`"
          :description="`Unless it is in Good Standing at expiration date, it is set to expire on ${showExpirationDate}. Otherwise we will attempt to expire the badge every ${retries_to_expire_in_days}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_has_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && expiration_date === null && showExpirationIconFeature" class="ex-badge-icon">
        <EXTooltip
          placement="bottom"
          title="Does Not expire"
          :children="true"
        >
          <template #icon>
            <ExpireIcon
              icon="read_only"
              :badgeLevel="level"
              :expirationDate="expiration_date"
            />
          </template>
        </EXTooltip>
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" hover class="readiness-chatter-icon" @onClick="onChatterClick" />
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && showExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Expires in ${showExpirationDays} days`"
          :description="`Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_expire" />
          </template>
        </EXTooltip>
      </div>
      <div v-if="view === 'ReadOnly' && dot === 'Given' && level !== 'Novice' && showAboutExpirationIcon && !has_expiration_if_obsolete && showExpirationIconFeature" class="badge-icon">
        <EXTooltip
          placement="bottom"
          :title="`Is about to expire in ${showExpirationDays} days`"
          :description="`Set to expire on ${showExpirationDate}`"
          :children="true"
        >
          <template #icon>
            <Icon name="badge_about_expire" />
          </template>
        </EXTooltip>
      </div>
      <img v-if="view === 'Editable' && level !== 'Novice' && !hideRemoveIcon" :src="require(`@components/assets/badge-cross-icon.png`)" alt="icon"
        @click="removeBadge(level)" class="badge-cross-icon">
    </v-chip>
    <v-chip v-if="plain === true && mini === false" :class="plainClasses">
      <img :src="require(`@components/assets/plainminimalistic.svg`)" alt="icon" class="plain-badge-image">
    </v-chip>
    <div
      v-if="firstName && lastName"
      :class="[holderClasses, { status: status !== 'Current' }]"
      class="pro-holder-badge"
    >
      <div class="pro-holder-badge-content">
        <EXTooltip
          :title="proficiencyDescription"
          placement="top"
          :position=true
        >
          <div class="pro-holder-badge-info">
            <v-badge
              :color="getStatusColor"
              dot
              class="prop-custom-bedge-holder"
            ></v-badge>
            <ExAvatar
              size="small"
              :picture="avatar || ''"
              :firstName="!avatar ? firstName : ''"
              :lastName="!avatar ? lastName : ''"
              class="custom-avatar"
            />
            <EXTooltip 
              v-if="isNameTruncated" 
              placement="top" 
              :title="`${firstName} ${lastName}`"
              :delay="300"
            >
              <span :class="holderTextClasses" class="holder-status-label truncated-badge-name">{{ firstName }} {{ lastName }}</span>
            </EXTooltip>
            <span v-else :class="holderTextClasses" class="holder-status-label">{{ firstName }} {{ lastName }}</span>
          </div>
        </EXTooltip>
        <ExpireIcon
          class="ex-holder-badge-icon"
          v-if="status === 'Current' && !hideIcons && showExpirationIconFeature"  
          :icon="expirationIconVariant"
          :badgeLevel="level"
          :expirationDate="expiration_date"
          :days="expires_in_days_from_becoming_obsolete || 0"
          :badgeStatus="expirationIconBadgeStatus"
          :policy="expirationIconPolicy"
          @save="handleExpirationSave"
          @remove="handleExpirationRemove"
          @setToGoodStanding="handleSetToGoodStanding"
          @makeObsolete="handleMakeObsolete"
        />
        <ChatterIcon v-if="!hideChatterIcon" :unread="unread" :is_white="isBlackBackground" class="readiness-chatter-icon" @onClick="onChatterClick" />
        <Icon :name="`ex_${status}`" v-if="status !== 'Current' && !hideIcons" />
      </div>
      <EXTooltip
        title="Remove"
        placement="top"
        :position="true"
      >
        <v-btn
          icon
          color="#98A2B3"
          class="avail-close-btn holder-cross-icon"
          :class="'hover-cross-' + level"
          @click="removeHolder(level)"
          :data-testid="'remove-badge-' + id"
          v-if="status === 'Current' && !hideRemoveIcon"
          @mouseover="isHovering = true"
          @mouseleave="isHovering = false"
        >
          <Icon :name="isHovering ? 'ex_pro_badge_holder_hover_close' : 'ex_pro_badge_holder_close'" />
        </v-btn>
      </EXTooltip>
    </div>
  </div>
</template>

<script setup>
import { computed, reactive, ref, getCurrentInstance, onMounted } from 'vue';
import Icon from "@components/icons/Icon.vue";
import EXTooltip from "@components/tooltip/EXTooltip.vue";
import ExpireIcon from "@components/ExpirationIcon/ExpirationIcon.vue";
import ChatterIcon from "@components/ChatterIcon/ChatterIcon.vue";
import dayjs from "dayjs";
import ExAvatar from "@components/common/ExAvatar.vue";

const instance = getCurrentInstance();
const { proxy } = instance;

// Props definition
const props = defineProps({
  level: {
    type: String,
    validator: function (value) {
      return ['Apprentice', 'Professional', 'Coach', 'Master', 'Novice'].indexOf(value) !== -1;
    },
  },
  dot: {
    type: String,
    validator: function (value) {
      return ['Good Standing', 'Given', 'Obsolete', 'No Dot'].indexOf(value) !== -1;
    },
  },
  view: {
    type: String,
    validator: function (value) {
      return ['Editable', 'ReadOnly', 'Null'].indexOf(value) !== -1;
    },
  },
  expiration_date: {
    type: Date,
    default: null
  },
  expires_in_days_from_becoming_obsolete: {
    type: Number,
    default: null
  },
  has_expiration_if_obsolete: {
    type: Boolean,
    default: false
  },
  retries_to_expire_in_days: {
    type: Number,
    default: 365
  },
  plain: {
    type: Boolean,
    default: false
  },
  mini: {
    type: Boolean,
    default: false
  },
  readinessView: {
    type: Boolean,
    default: false,
  },
  hideRemoveIcon: {
    type: Boolean,
    default: false,
  },
  hideIcons: {
    type: Boolean,
    default: false,
  },
  upgraded: {
    type: Boolean,
    default: false
  },
  upgradedVariantIcon: {
    type: String,
    validator: function (value) {
      return ['expired', 'removed', 'upgraded'].indexOf(value) !== -1;
    },
  },
  showNoviceButton: {
    type: Boolean,
    default: false,
  },
  oldLevel: {
    type: String,
    validator: function (value) {
      return ['Apprentice', 'Professional', 'Coach', 'Master', 'Novice'].indexOf(value) !== -1;
    },
  },
  oldDot: {
    type: String,
    validator: function (value) {
      return ['Good Standing', 'Given', 'Obsolete', 'No Dot'].indexOf(value) !== -1;
    },
  },
  status: {
    type: String,
    default: 'Current',
    validator: function (value) {
      return ['Current', 'Expired', 'Terminated', 'Removed'].indexOf(value) !== -1;
    },
  },
  firstName: {
    type: String,
    default: ''
  },
  lastName: {
    type: String,
    default: ''
  },
  avatar: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 1
  },
  acting_as_coach: {
    type: Boolean,
    default: false
  },
  acting_as_master: {
    type: Boolean,
    default: false
  },
  unread: {
    type: Number,
    default: 0
  },
  withoutFeatureFlag: {
    type: Boolean,
    default: false
  },
  hideChatterIcon: {
    type: Boolean,
    default: false
  }
});

// Emits definition
const emit = defineEmits([
  'removeBadge',
  'noviceBadge',
  'removeHolder',
  'updateExpirationDate',
  'removeExpirationDate',
  'setToGoodStanding',
  'makeObsolete',
  'chatter-click',  // <-- Add this
]);

// Reactive data
const state = reactive({
  tooltipVisible: false
});
const isHovering = ref(false);

// Feature flag for expiration icon
const showExpirationIconFeature = computed(() => {
  if (props.withoutFeatureFlag) {
    return true;
  }
  return proxy.flags?.['idea-MDP-11'] || false;
});

// Computed properties
const getTooltipValue = computed(() => {
  if (props.view === 'Removed' && props.level !== 'Novice' && props.expiration_date === null) {
    return `${props.level} in ${props.dot} Removed`;
  } else if (props.view === 'Expired' && props.level !== 'Novice' && props.expiration_date === null && props.dot !== "Obsolete") {
    return `${props.level} in ${props.dot} Expired`;
  } else if (props.view === 'Expired' && props.level !== 'Novice' && props.expiration_date === null && props.dot === "Obsolete") {
    return `${props.level} ${props.dot} Expired`;
  } else if (props.upgraded && props.level !== 'Novice' && props.upgradedVariantIcon === "upgraded") {
    return `Upgraded to ${props.level} ${props.dot}`;
  } else {
    let string = props.level;
    if (props.dot !== "No Dot") {
      string += ' '
      string += props.dot
    }
    return string;
  }
});

const getStatusColor = computed(() => {
  switch (props.dot) {
    case 'Good Standing':
      return '#17B26A';
    case 'Given':
      return '#2C2C2C';
    default:
      return '#FF0303';
  }
});

const isBlackBackground = computed(() => {
  return ["Expired", "Removed", "Terminated"].includes(props.view) || props.upgraded;
});

const classes = computed(() => {
  const levelClass = `proficiency-badge--${props.level}`;
  return {
    [levelClass]: true,
    "black-background": isBlackBackground.value,
  };
});

const holderClasses = computed(() => {
  return {
    [`holder-badge--${props.level}`]: true,
  };
});

const miniClasses = computed(() => {
  const levelLower = (typeof props.level === 'string' && props.level.length > 0)
    ? props.level.toLowerCase()
    : 'novice';
  return {
    [`proficiency-badge-mini--${levelLower}`]: true,
    [`proficiency-badge-mini`]: true,
  };
});

const plainClasses = computed(() => {
  if (props.level && props.level.length > 0) {
    return {
      [`proficiency-badge-plain--${props?.level?.toLowerCase() || ''}`]: true,
    };
  }
  else {
    return {}
  }
});

const textClasses = computed(() => {
  return {
    [`proficiency-text--${props.level}${props.upgraded ? '__upgraded' : ''}`]: true,
    'ml-3': (props.level !== 'Novice' && props.dot !== 'No Dot'),
  };
});

const isNameTruncated = computed(() => {
  const fullName = `${props.firstName} ${props.lastName}`.trim();
  return fullName.length > 20; // Show tooltip if name is longer than 20 characters
});

const holderTextClasses = computed(() => {
  return {
    [`holder-text--${props.level}`]: true,
  };
});

const showExpirationIcon = computed(() => {
  const today = dayjs();
  const expirationDateMinus30Days = dayjs(props.expiration_date).subtract(30, 'days');
  return (
    props.expiration_date !== null &&
    today.isBefore(expirationDateMinus30Days)
  );
});

const showExpirationDays = computed(() => {
  const today = dayjs();
  const expirationDate = dayjs(props.expiration_date);
  const diffInDays = expirationDate.diff(today, 'day');
  return diffInDays;
});

const showExpirationDate = computed(() => {
  return dayjs(props.expiration_date).format("DD-MMMM-YYYY");
});

const showAboutExpirationIcon = computed(() => {
  const today = dayjs();
  const expirationDateMinus30Days = dayjs(props.expiration_date).subtract(30, 'days');
  return (
    props.expiration_date !== null &&
    today.isAfter(expirationDateMinus30Days) &&
    today.isBefore(props.expiration_date)
  );
});

const showTodayExpirationIcon = computed(() => {
  const today = new Date();
  const expirationDate = new Date(props.expiration_date);
  today.setHours(0, 0, 0, 0);
  expirationDate.setHours(0, 0, 0, 0);
  const diffDays = Math.floor((expirationDate - today) / (1000 * 60 * 60 * 24));
  return (
    diffDays === 0
  );
});

const proficiencyDescription = computed(() => {
  switch (props.level) {
    case 'Apprentice':
      return `Apprentice ${props.dot}`;
    case 'Professional':
      return `Professional ${props.dot}`;
    case 'Coach':
      return `Coach ${props.dot}`;
    case 'Master':
      return `Master ${props.dot}`;
    default:
      return '';
  }
});

const expirationIconVariant = computed(() => {
  if (props.expires_in_days_from_becoming_obsolete !== null && props.expires_in_days_from_becoming_obsolete > 0) {
    return 'if_obsolete';
  }
  
  if (props.dot === 'Given' || props.dot === 'Good Standing' || props.dot === 'Obsolete') {
    if (props.expiration_date === null) {
      return 'add';
    }
    return 'edit';
  }
  
  return 'add';
});

const expirationIconPolicy = computed(() => {
  if (props.expires_in_days_from_becoming_obsolete !== null && props.expires_in_days_from_becoming_obsolete > 0) {
    return 'Days';
  }
  
  if (props.expiration_date !== null) {
    return 'Date';
  }
  
  return 'Date';
});

const expirationIconBadgeStatus = computed(() => {
  return props.dot;
});

const removeBadge = ($event) => {
  emit('removeBadge', $event);
};

const noviceBadge = ($event) => {
  emit('noviceBadge', $event);
};

const removeHolder = ($event) => {
  // Emit both removeHolder (for backward compatibility) and removeBadge (for new flow)
  emit('removeHolder', $event);
  // Emit removeBadge event - the parent (EmployeeBadgeHolderList) will pass the full badge data
  // We just need to trigger the event, the parent handles the data
  emit('removeBadge');
};

const handleExpirationSave = (data) => {
  console.log('ReadinessBadge - Received save event with data:', data);
  emit('updateExpirationDate', data);
};

const handleExpirationRemove = () => {
  console.log('ReadinessBadge - Remove expiration date requested');
  emit('removeExpirationDate');
};

const handleSetToGoodStanding = () => {
  console.log('ReadinessBadge - Set to Good Standing requested');
  emit('setToGoodStanding');
};

const handleMakeObsolete = (data) => {
  console.log('ReadinessBadge - Make obsolete requested with days:', data.days);
  emit('makeObsolete', data);
};
// Handler to emit chatter-click
const onChatterClick = (event) => {
  emit('chatter-click', {
    level: props.level,
    dot: props.dot,
    view: props.view,
    expiration_date: props.expiration_date,
    badgeProps: {...props},
  });
};
// Initialize feature flag
onMounted(async () => {
  try {
    await proxy.$watchFlag('idea-MDP-11', false);
  } catch (error) {
    console.error('Error loading idea-MDP-11 feature flag:', error);
  }
});

</script>

<style>
.ex-readiness-badge {
  display: flex;
  align-items: center;
  position: relative;
}

.ex-readiness-badge .v-chip {
  overflow: visible !important;
}

.ex-readiness-badge .v-chip .v-chip__content {
  overflow: visible !important;
}

.ex-readiness-badge .proficiency-badge--Apprentice {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color:#E58700 !important;
  background-color: #FFF5D3 !important;
}

.ex-readiness-badge .proficiency-badge--Professional {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color: #00B813 !important;
  background-color: #F3FFF9 !important;
}

.ex-readiness-badge .proficiency-badge--Coach {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color: #00A3FF !important;
  background-color: #EFFEFF !important;
}

.ex-readiness-badge .proficiency-badge--Master {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color: #2E1EC1 !important;
  background-color: #F2F3FF !important;
}

.ex-readiness-badge .proficiency-badge--Novice {
  padding: 2px 18px 2px 18px;
  height: 32px !important;
  border-radius: 6px !important;
  border: 1px solid #D0D5DD;
  background-color: #FF0303 !important;
  box-shadow: 0px 1px 2px 0px #1018280D;
}

.ex-readiness-badge .black-background {
  background-color: #666666 !important;
  border-color: black !important;
}

.ex-readiness-badge .proficiency-text--Apprentice {
  color: #E58700 !important;
}

.ex-readiness-badge .proficiency-text--Professional {
  color: #00B813 !important;
}

.ex-readiness-badge .proficiency-text--Coach {
  color: #00A3FF !important;
}

.ex-readiness-badge .proficiency-text--Master {
  color: #2E1EC1 !important;
}

.ex-readiness-badge .proficiency-text--Novice {
  margin-left: 0px !important;
  color: #FFFFFF !important;
}

.ex-readiness-badge .proficiency-text--Apprentice__upgraded {
  color: #FFB346 !important;
}

.ex-readiness-badge .proficiency-text--Professional__upgraded {
  color: #00FF19 !important;
}

.ex-readiness-badge .proficiency-text--Coach__upgraded {
  color: #8DD6FF !important;
}

.ex-readiness-badge .proficiency-text--Master__upgraded {
  color: #768DFF !important;
}

.ex-readiness-badge .prop-custom-bedge.v-badge--dot .v-badge__badge {
  width: 6px;
  height: 6px;
  inset: auto auto calc(100% - 3px) calc(100% - 0px) !important;
}

.ex-readiness-badge .prop-status-label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}

.ex-readiness-badge .badge-cross-icon {
  padding: 2px;
  border-radius: 50%;
  cursor: pointer;
}

.ex-readiness-badge .novice-btn {
  width: 57px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid #7F56D9;
  background-color: #7F56D9;
  box-shadow: 0px 1px 2px 0px #1018280D;
  position: relative;
  left: 14px;
  top: 0px;
  text-align: center;
  cursor: pointer;
}

.ex-readiness-badge .novice-plus {
  position: relative;
  top: -1px;
}

.ex-readiness-badge .novice-badge {
  position: relative;
  top: 1px;
}

.ex-readiness-badge .badge-icon {
  position: relative;
  padding-left: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1px;
  gap: 6px;
  overflow: visible;
}

.ex-readiness-badge .ex-badge-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  overflow: visible;
  margin-left: 5px;
}

.chatterIcon-zero > svg {
  position: relative;
  top: -1px;
}

.ex-readiness-badge .proficiency-badge-plain--apprentice {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #FFF5D3 !important;
  border-color: #E58700 !important;
  width: 24px;
  height: 24px !important;
}

.ex-readiness-badge .proficiency-badge-plain--professional {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #F3FFF9 !important;
  border-color: #00B813 !important;
  width: 24px;
  height: 24px !important;
}

.ex-readiness-badge .proficiency-badge-plain--coach {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #EFFEFF !important;
  border-color: #00A3FF !important;
  width: 24px;
  height: 24px !important;
}

.ex-readiness-badge .proficiency-badge-plain--master {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #F2F3FF !important;
  border-color: #2E1EC1 !important;
  width: 24px;
  height: 24px !important;
}

.ex-readiness-badge .proficiency-badge-plain--novice {
  border-radius: 6px !important;
  border: 1px solid #D0D5DD;
  background-color: #FFFFFF !important;
  box-shadow: 0px 1px 2px 0px #1018280D;
  width: 24px;
  height: 24px !important;
}

.ex-readiness-badge .plain-badge-image {
  width: 20px;
  height: 20px;
}

.ex-readiness-badge .proficiency-badge-mini--apprentice {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #FFF5D3 !important;
  border-color: #E58700 !important;
  padding: 4px;
}

.ex-readiness-badge .proficiency-badge-mini--professional {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #F3FFF9 !important;
  border-color: #00B813 !important;
  padding: 4px;
}

.ex-readiness-badge .proficiency-badge-mini--coach {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #EFFEFF !important;
  border-color: #00A3FF !important;
  padding: 4px;
}

.ex-readiness-badge .proficiency-badge-mini--master {
  border-radius: 6px !important;
  border: 1px solid;
  background-color: #F2F3FF !important;
  border-color: #2E1EC1 !important;
  padding: 4px;
}

.ex-readiness-badge .proficiency-badge-mini {
  height: 24px !important;
}

.ex-readiness-badge .proficiency-badge-mini .prop-custom-bedge {
  position: relative;
  left: 2px;
}

.ex-readiness-badge .proficiency-badge-mini .badge-icon {
  padding-left: 1px;
}

.ex-readiness-badge .proficiency-badge-mini .badge-icon ._icon {
  width: 16px;
}

.ex-readiness-badge img.badge-cross-icon:hover {
  cursor: url('../assets/cursorArrow.svg'), auto;
}

.ex-readiness-badge .hover-cross-Apprentice:hover, .hover-cross-apprentice:hover {
  background-color: #E58700;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Professional:hover, .hover-cross-professional:hover {
  background-color: #00B813;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Coach:hover, .hover-cross-coach:hover {
  background-color: #00A3FF;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Master:hover, .hover-cross-master:hover {
  background-color: #2E1EC1;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .readiness-view-proficiency-badge {
  margin: auto !important;
}

.ex-readiness-badge .readiness-view-proficiency-badge .v-chip {
  width: 120px !important;
  height: 24px !important;
}

.ex-readiness-badge .readiness-view-proficiency-badge .v-chip .v-chip__content {
  margin: auto !important;
}

.ex-readiness-badge .readiness-view-proficiency-badge .v-chip .v-chip__content .el-tooltip,
.ex-readiness-badge .readiness-view-proficiency-badge .v-chip .v-chip__content .el-tooltip > div:first-child {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ex-readiness-badge .prop-custom-bedge-holder.v-badge--dot .v-badge__badge {
  width: 6px;
  height: 6px;
  inset: auto auto calc(100% - 3px) calc(100% - 5px) !important;
}

.ex-readiness-badge  { 
  width: fit-content !important;
}

.ex-readiness-badge .holder-badge--Apprentice {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color:#E58700 !important;
  background-color: #FFF3E0 !important;
  height: 32px;
  display: inline-flex;
  align-items: center;
  column-gap: 7px;
  padding: 0px 8px 0px 14px;
}

.ex-readiness-badge .holder-badge--Professional {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color:#00B813 !important;
  background-color: #EFFFEF !important;
  height: 32px;
  display: inline-flex;
  align-items: center;
  column-gap: 7px;
  padding: 0px 8px 0px 14px;
}

.ex-readiness-badge .holder-badge--Coach {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color: #00A3FF !important;
  background-color: #EFFEFF !important;
  height: 32px;
  display: inline-flex;
  align-items: center;
  column-gap: 7px;
  padding: 0px 8px 0px 14px;
}

.ex-readiness-badge .holder-badge--Master {
  border-radius: 16px !important;
  border: 1px solid !important;
  border-color: #2E1EC1 !important;
  background-color: #F2F3FF !important;
  height: 32px;
  display: inline-flex;
  align-items: center;
  column-gap: 7px;
  padding: 0px 8px 0px 14px;
}

.ex-readiness-badge .holder-text--Apprentice {
  color: #E58700 !important;
}

.ex-readiness-badge .holder-text--Professional {
  color: #00B813 !important;
}

.ex-readiness-badge .holder-text--Coach {
  color: #00A3FF !important;
}

.ex-readiness-badge .holder-text--Master {
  color: #2E1EC1 !important;
}

.ex-readiness-badge .holder-status-label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: center;
}

.ex-readiness-badge .holder-cross-icon {
  padding: 2px;
  border-radius: 50%;
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.ex-readiness-badge .holder-cross-icon:hover {
    cursor: url('../assets/cursorArrow.svg'), auto;
}

.ex-readiness-badge .hover-cross-Apprentice:hover {
  background-color: #E58700;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Professional:hover {
  background-color: #00B813;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Coach:hover {
  background-color: #00A3FF;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .hover-cross-Master:hover {
  background-color: #2E1EC1;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.ex-readiness-badge .ex-holder-badge-icon {
  margin-top: -2px;
}

.ex-readiness-badge .pro-holder-badge-content {
  display: flex;
  align-items: center;
  top: 3px;
}

.ex-readiness-badge .pro-holder-badge-info {
  display: flex;
  align-items: center;
}

.ex-readiness-badge .pro-holder-badge .custom-avatar {
  height: 16px !important;
  min-width: 16px !important;
  width: 16px !important;
  top: 0px;
}

.ex-readiness-badge .status {
  background-color: #666666 !important;
  border: 1px solid #000000 !important;
}

.ex-readiness-badge .pro-holder-badge .v-btn--icon.v-size--default {
  height: 18px;
  width: 18px;
}

.ex-readiness-badge .truncated-badge-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
</style>

<style scoped>
::v-deep(.v-chip) {
  line-height: normal !important;
}

:v-deep(.chatter-icon-com) {
  margin-top: -1px !important;
}

::v-deep(.chatter-icon-com.chatterIcon-unread div .unread-badge) {
  margin: 1px -1px;
}

::v-deep(.chatter-icon-com.is-white.chatterIcon-unread div .unread-badge) {
  margin: -1px -1px !important;
}

::v-deep(.proficiency-badge-mini .chatter-icon-com svg) {
  height: 15px !important;
  width: 13px !important;
  top: -2px !important;
}

.pro-holder-badge-content  {
  position: relative;
  left: 8px;
  top: 0px;
}

.pro-holder-badge-content .prop-custom-bedge-holder  {
  left: -5px;
  position: relative;
}

::v-deep(.chatter-icon-com.chatterIcon-zero) {
  padding: 0px !important;
}
::v-deep(.chatter-icon-com.chatterIcon-zero:hover) {
  padding: 0px !important;
}

::v-deep(.chatter-icon-com.is-white.chatterIcon-zero) {
  background-color: transparent !important;
  margin-top: -5px !important;
  width: 25px;
  height: 25px;
  position: relative;
  left: 3px;
}
::v-deep(.chatter-icon-com.is-white.chatterIcon-zero div > svg) {
  top: 3px !important;
}
::v-deep(.chatter-icon-com.is-white.chatterIcon-unread) {
  margin-top: -5px !important;
}

::v-deep(.chatter-icon-com.is-white.chatterIcon-unread) {
  padding: 4px 4px 0px 4px !important;
}
::v-deep(.chatter-icon-com.is-white.chatterIcon-unread:hover) {
  padding: 4px 4px 0px 4px !important;
}

::v-deep(.chatter-icon-com.chatterIcon-unread) {
  padding: 0px 3px 0px 3px !important;
}
::v-deep(.chatter-icon-com.chatterIcon-unread:hover) {
  padding: 0px 3px 0px 3px !important;
}

::v-deep(.pro-holder-badge-content .chatter-icon-com) {
  padding: 2px 2px 0px 2px !important;
}
::v-deep(.pro-holder-badge-content .chatter-icon-com:hover) {
  padding: 2px 2px 0px 2px !important;
}

::v-deep(.pro-holder-badge-content .chatterIcon-zero div > svg ) {
  position: relative;
  top: 1px !important;
  left: 0px;
}

::v-deep(.pro-holder-badge-content .chatterIcon-unread div > svg ) {
  position: relative;
  top: 1px;
  left: 0px;
}

::v-deep(.pro-holder-badge-content .chatterIcon-unread div .unread-badge  ) {
  top: -3px;
  right: -2px;
}

::v-deep(.pro-holder-badge .avail-close-btn ) {
  margin-left: 5px !important;
}

.pro-holder-badge-info {
  margin-right: 5px !important;
}

::v-deep(.pro-holder-badge .custom-avatar){
  margin: 0px 5px !important;
}

</style>